import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoGoogle24 = t0 => {
  const $ = _c(7);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M18.5372 10.6943H18.0002V10.6666H12.0002V13.3333H15.7678C15.2182 14.8856 13.7412 16 12.0002 16C9.79116 16 8.00016 14.209 8.00016 12C8.00016 9.79098 9.79116 7.99998 12.0002 7.99998C13.0198 7.99998 13.9475 8.38465 14.6538 9.01298L16.5395 7.12731C15.3488 6.01765 13.7562 5.33331 12.0002 5.33331C8.3185 5.33331 5.3335 8.31831 5.3335 12C5.3335 15.6816 8.3185 18.6666 12.0002 18.6666C15.6818 18.6666 18.6668 15.6816 18.6668 12C18.6668 11.553 18.6208 11.1166 18.5372 10.6943Z" fill="#FFC107" />;
    t2 = <path d="M6.10156 8.89698L8.2919 10.5033C8.88456 9.03598 10.3199 7.99998 11.9996 7.99998C13.0192 7.99998 13.9469 8.38465 14.6532 9.01298L16.5389 7.12731C15.3482 6.01765 13.7556 5.33331 11.9996 5.33331C9.4389 5.33331 7.21823 6.77898 6.10156 8.89698Z" fill="#FF3D00" />;
    t3 = <path d="M11.9999 18.6667C13.7219 18.6667 15.2866 18.0077 16.4696 16.936L14.4063 15.19C13.7369 15.697 12.9049 16 11.9999 16C10.2659 16 8.79361 14.8944 8.23894 13.3514L6.06494 15.0264C7.16827 17.1854 9.40894 18.6667 11.9999 18.6667Z" fill="#4CAF50" />;
    t4 = <path d="M18.537 10.6943H18V10.6666H12V13.3333H15.7677C15.5037 14.079 15.024 14.722 14.4053 15.1903C14.4057 15.19 14.406 15.19 14.4063 15.1896L16.4697 16.9356C16.3237 17.0683 18.6667 15.3333 18.6667 12C18.6667 11.553 18.6207 11.1166 18.537 10.6943Z" fill="#1976D2" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== ariaLabel || $[5] !== className) {
    t5 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}{t3}{t4}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default IcoGoogle24;